import { Component, Input } from '@angular/core';
import { AccessControlController } from '@shared/src/controllers/accesscontrol/accesscontrol.controller';
import { AccessControlPhaseTransitionsDto } from '@shared/src/dtos/accesscontrol/AccessControlPhaseTransitionsDto';
import { HColor } from '@shared/src/datatypes/HColor';
import { HLong } from '@shared/src/datatypes/HLong';

@Component({
  selector: 'shared-accesscontrol-transitions',
  templateUrl: './shared.accesscontrol.transitions.component.html',
  styleUrls: ['./shared.accesscontrol.transitions.component.scss']
})
export class SharedAccessControlTransitionsComponent {

  constructor(private accessControlController: AccessControlController) { }

  public data: AccessControlPhaseTransitionsDto | null = null;

  private _accessControlId: number = 0;
  public get accessControlId(): number {
    return this._accessControlId;
  }
  @Input()
  public set accessControlId(value: number) {
    if (this._accessControlId === value)
      return;
    this._accessControlId = value;
    this.loadDataIfReady();
  }

  private _phaseId: number = 0;
  public get phaseId(): number {
    return this._phaseId;
  }
  @Input()
  public set phaseId(value: number) {
    if (this._phaseId === value)
      return;
    this._phaseId = value;
    this.loadDataIfReady();
  }

  public getBackColor(value: any): string {
    return HColor.getColor(value, '#eeeeee');
  }

  public getForeColor(value: any): string {
    return HColor.getColor(value, '#000000');
  }

  private loadDataIfReady() {
    if (HLong.isNullOrNullLong(this._accessControlId) || HLong.isNullOrNullLong(this._phaseId)) {
      this.data = null;
      return;
    }
    this.accessControlController.getPhaseTransitions(this._accessControlId, this._phaseId).subscribe(result => {
      this.data = AccessControlPhaseTransitionsDto.build(result);
    });
  }
}
